import { render } from "./GuestLayout.vue?vue&type=template&id=7b1a73de"
const script = {}
script.render = render

export default script